module.exports = __webpack_public_path__ + "static/media/8OLA25.48694191.jpg";